<template>
  <div>
    <h2 class="text-center">Clac Partners Login</h2>
    <transition name="slide-fade">
      <div class="toast toast-error" v-if="error">
        <button class="btn btn-clear float-right" @click.prevent="error = null"></button>
        {{error.code}} - {{error.message}}
        <ul v-if="error.errors">
          <li v-for="item in error.errors" :key="item.message">
            <small>{{item.message}} - {{item.reason}}</small>
          </li>
        </ul>
      </div>
    </transition>
    <div class="login" method="post" novalidate="true" @submit.prevent="login">
      <form class="form-horizontal">
        <div class="form-group">
          <div class="col-3 col-sm-12">
            <label class="form-label" :class="{'is-error' : errors.has('email') }" for="email">Email</label>
          </div>
          <div class="col-9 col-sm-12">
            <input
              class="form-input"
              name="email"
              v-validate="'required|email'"
              v-model="email"
              :class="{'is-error' : errors.has('email') }"
            >
            <span class="form-input-hint">{{ errors.first('email') }}</span>
          </div>
        </div>
        <div class="form-group">
          <div class="col-3 col-sm-12">
            <label
              class="form-label"
              :class="{'is-error' : errors.has('password') }"
              for="password"
            >Password</label>
          </div>
          <div class="col-9 col-sm-12">
            <input
              class="form-input"
              name="password"
              v-validate="'required'"
              type="password"
              v-model="password"
              rows="4"
              :class="{'is-error' : errors.has('password') }"
            >
            <span class="form-input-hint">{{ errors.first('password') }}</span>
          </div>
        </div>
        <br>
        <div class="form-group">
          <div class="col-9 col-sm-12 col-ml-auto">
            <button class="btn btn-block btn-primary" :class="{ loading: loading}">Login</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<style lang="stylus" scoped>
.login {
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #EEE;
  border-radius: 15px;
}

/* Enter and leave animations can use different */
/* durations and timing functions. */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter {
  transform: translateY(20px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
<script>
import fb from "@/firebase";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      loading: false,
      email: "",
      password: "",
      error: null
    };
  },
  computed: {},
  created() {},
  watch: {},
  mounted: function() {},
  methods: {
    login() {
      this.loading = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log(this.email, this.password);
          fb.auth
            .signInWithEmailAndPassword(this.email, this.password)
            .then(response => {
              console.log("signInSuccessWithAuthResult", response);
              this.$store.commit("setCurrentUser", fb.auth.currentUser);
              this.$router.push({ name: "home" });
              this.loading = false;
            })
            .catch(error => {
              this.error = error;
              this.loading = false;
              setTimeout(() => {
                this.error = null;
              }, 6000);
            });
        } else {
          console.log("Not valid form");
        }
      });
    }
  }
};
</script>
